module.exports = function calendlyPopup() {
    Calendly.initInlineWidget({
        url: $('#calendlyModal').data('url'),
        parentElement: $('#calendlyModal .popup-body')
    });
};